const s = "guests";
export {
  s as GUESTS
};
